import React, {Component} from 'react'
import parse from 'html-react-parser';

class Error extends Component {
  constructor(props) {
    super(props)

    this.state = {
      drawerOpen: false
    }
  }

  render() {
    return (
      <div className={`page page__error ${this.props.className}`}>

        <h1>{this.props.title}</h1>

        <div className="content-container">
          <p className="txt-lg">{this.props.description}</p>
          {this.props.longDescription && this.props.longDescription.hasOwnProperty('length') && this.props.longDescription.length > -1 ?
            (<p className="txt-md">{parse(this.props.longDescription)}<br /><br /></p>) : '' }
          {this.props.hideContactInfo ? null : <p className="txt-md">Please <a href="https://www.vu.edu.au/contact-us" target="_blank">contact VUHQ</a> for further information.</p>}
        </div>
      </div>
    )
  }
}

export default Error
